export enum RentalVehicleFormMode {
  NEW = 'new',
  EDIT = 'edit',
  CLONE = 'clone',
  NEW_FROM_SALE_OR_SERVICE = 'newFromSaleOrService',
}
